import React from "react";

import { Textfield } from "./Textfield";
import { InputAdornment } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

export function SearchInput(props) {
    return <Textfield
        {...props}
        InputProps={{
            startAdornment: (
                <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                </InputAdornment>
            ),
        }}
        fullWidth
    />
}